<template>
    <div class="record-customer loading-content-container">
        <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-if="!isLoading">
            <b-col cols="8">
                <b-row>
                    <csp-desktop-customer-basedata
                        :form-context="initialFormContexts.customerBasedata"/>
                </b-row>
            </b-col>
            <b-col cols="4">
                <b-row>
                    <csp-desktop-customer-bankaccount
                        :form-context="initialFormContexts.customerBankAccount"/>
                </b-row>
                <b-row class="mt-4">
                    <csp-desktop-customer-insurance-liability
                        :form-context="initialFormContexts.customerInsuranceLiability"/>
                </b-row>
                <b-row class="mt-4">
                    <csp-desktop-customer-insurance-legal-expense
                        :form-context="initialFormContexts.customerInsuranceLegalExpense"/>
                </b-row>
                <b-row class="mt-4">
                    <csp-desktop-customer-insurance-breakdown-cover
                        :form-context="initialFormContexts.customerInsuranceBreakdownCover"/>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import CustomerBasedata from '@desktop/components/record/customer/CustomerBasedata.vue';
    import CustomerInsuranceBreakdownCover from
    '@desktop/components/record/customer/CustomerInsuranceBreakdownCover.vue';
    import CustomerInsuranceLiability from '@desktop/components/record/customer/CustomerInsuranceLiability.vue';
    import CustomerInsuranceLegalExpense from '@desktop/components/record/customer/CustomerInsuranceLegalExpense.vue';
    import CustomerBankAccount from '@desktop/components/record/customer/CustomerBankAccount.vue';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'RecordCustomer',
        components: {
            'csp-desktop-customer-basedata': CustomerBasedata,
            'csp-desktop-customer-insurance-breakdown-cover': CustomerInsuranceBreakdownCover,
            'csp-desktop-customer-insurance-liability': CustomerInsuranceLiability,
            'csp-desktop-customer-insurance-legal-expense': CustomerInsuranceLegalExpense,
            'csp-desktop-customer-bankaccount': CustomerBankAccount,
        },
        mixins: [FormDataMixin],
        data() {
            const recordId = this.$route.params.recordId;
            return {
                recordId,
                isLoading: true,
                initialFormContexts: {
                    customerBasedata: new FormContext({
                        name: 'customerBasedata',
                        objectId: recordId,
                        reloadFields: [],
                    }),
                    customerInsuranceBreakdownCover: new FormContext({
                        name: 'customerInsuranceBreakdownCover',
                        objectId: recordId,
                    }),
                    customerInsuranceLegalExpense: new FormContext({
                        name: 'customerInsuranceLegalExpense',
                        objectId: recordId,
                    }),
                    customerInsuranceLiability: new FormContext({
                        name: 'customerInsuranceLiability',
                        objectId: recordId,
                    }),
                    customerBankAccount: new FormContext({
                        name: 'customerBankAccount',
                        objectId: recordId,
                    }),
                },
            }
        },
        created() {
            const loadFunction = () => {
                return recordRepository.loadCustomerOverview(this.recordId);
            }
            this.loadFormData(loadFunction).finally(() => {
                this.isLoading = false;
            });
        },
    }
</script>
